import ChatMobile from "../components/layout/ChatMobile";
import Footer from "../components/layout/Footer";
import LayoutMobile from "../components/layout/LayoutMobile";
import NotFound from "../pages/404NotFound";
import BrandsDetailPageCategory from "../pages/BrandsDetailPageCategory";
import Categorypage from "../pages/Categorypage";
import FAQPage from "../pages/FAQPage";
import LoginPage from "../pages/LoginPage";
import AboutUsMobilePage from "../pages/mobile/AboutUsMobilePage";
import BlogsDetailMobilePage from "../pages/mobile/BlogsDetailMobilePage";
import BlogsMobilePage from "../pages/mobile/BlogsMobilePage";
import BrandsDetailMobilePage from "../pages/mobile/BrandsDetailMobilePage";
import BrandsMobilePage from "../pages/mobile/BrandsMobilePage";
import CategoryPage from "../pages/mobile/CategoryPage";
import ComapreMobilePage from "../pages/mobile/ComapreMobilePage";
import ContactUsPageMobile from "../pages/mobile/ContactUsPageMobile";
import Discounted from "../pages/mobile/Discounted";
import HomePageMobile from "../pages/mobile/HomePage";
import PayLaterMobilePage from "../pages/mobile/PayLaterMobilePage";
import ProductDetailsMobile from "../pages/mobile/ProductDetailsMobile";
import StoryPage from "../pages/mobile/StoryPage";
import TargetedBuyMobilePage from "../pages/mobile/TargetedBuyMobilePage";
import WorkWithUsMobilePage from "../pages/mobile/WorkWithUsMobilePage";
import UrlDetailPageCategory from "../pages/UrlDetailPageCategory";
import ScrollToTop from "../utils/ScrooltoTop";

export const MOBILE_ROUTES = [
  {
    path: "*",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <NotFound />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/auth/login",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <LoginPage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <HomePageMobile />
        <Footer />
      </div>
    ),
  },
  {
    path: "/chat",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile footer />
        <ChatMobile />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/category",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <CategoryPage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/pay-later",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <PayLaterMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/work-with-us",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <WorkWithUsMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/compare",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <ComapreMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/brands",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <BrandsMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/brands/:name",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <BrandsDetailMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/targeted-buy",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <TargetedBuyMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/about",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <AboutUsMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/story",
    element: (
      <div dir="rtl">
        <StoryPage />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/faq",
    element: (
      <div dir="rtl" className=" pb-[68px]">
        <LayoutMobile />
        <FAQPage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/discounted",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <Discounted />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/contact",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <ContactUsPageMobile />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/:category/:brand/:name/:vehicle_number",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <ProductDetailsMobile />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/blogs",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <BlogsMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/blogs/:name",
    element: (
      <div
        dir="rtl"
        className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
      >
        <LayoutMobile />
        <BlogsDetailMobilePage />
        <Footer />
        <ScrollToTop />
      </div>
    ),
  },
  {
    path: "/:category/:brand",
    element: (
      <>
        <div
          dir="rtl"
          className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
        >
          <LayoutMobile />
          <BrandsDetailPageCategory />
          <Footer />
          <ScrollToTop />
        </div>
      </>
    ),
  },
  {
    path: "/:category/:brand/:name",
    element: (
      <>
        <div
          dir="rtl"
          className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
        >
          <LayoutMobile />
          <UrlDetailPageCategory />
          <Footer />
          <ScrollToTop />
        </div>
      </>
    ),
  },
  {
    path: "/:category",
    element: (
      <>
        <div
          dir="rtl"
          className="pt-[84px] pb-[68px] px-4  text-[12px] sm:text[14px]"
        >
          <LayoutMobile />
          <Categorypage mobile />
          <Footer />
          <ScrollToTop />
        </div>
      </>
    ),
  },
];
